/*
 * @Author: your name
 * @Date: 2021-08-26 09:49:59
 * @LastEditTime: 2021-10-09 15:02:36
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/api/learningGuidePage/index.js
 */
// 课程详情页公共API存放，例：课程详情；
import ajax from '@/utils/ajax';
import { head } from '@/api/personal/personalSet';

const header = '/web';
// 提交评价
// eslint-disable-next-line import/prefer-default-export
export const reqProductEvaluation = (data) => ajax(`${header}/v1/course-evaluation`, data, 'POST');

// 详情页产品评价
export const reqGetEvaluationProduct = (productId, pageNum, pageSize) => ajax(`${header}/v1/course-evaluation/product-detail?productId=${productId}&pageNum=${pageNum}&pageSize=${pageSize}`);

// 导学页产品评价
export const reqGetEvaluationGuidance = (data) => ajax(`${header}/v1/course-evaluation/detail${data}`);

// 导学页用户课程详情
export async function reqCourseDetail(params) {
  const res = await ajax(`${head}/v1/user/course/info`, params);
  return res;
}

// 获取课表
export const reqGetCatalog = (id) => ajax(`${header}/v1/course/catalog/${id}`);

// 导学页获取用户课程中正在直播内容
export const reqBroadcasting = (userProductId) => ajax(`${header}/v1/user/course/Live/broadcasting?userProductId=${userProductId}`);

// 查询用户学习报告
export const reqStudyReport = (userProductId) => ajax(`${header}/v1/user-learn-report/select?userProductId=${userProductId}`);

// 获取任务列表
export const getTaskApi = (value) => ajax(`${header}/v1/lms/user-examination/learn-questionnaire?userProductId=${value}`, '', 'GET');

// 查询用户学习报告基础信息
export const reqStudyBasisInfo = (userProductId) => ajax(`${header}/v1/user-learn-report/basis-info?userProductId=${userProductId}`);

// 查询用户学习报告考试信息
export const reqStudyExamInfo = (userProductId, pageNum, pageSize) => ajax(`${header}/v1/user-learn-report/exam-info?userProductId=${userProductId}&pageSize=${pageSize}&pageNum=${pageNum}`);

// 查询用户学习报告服务信息
export const reqStudyServiceInfo = (userProductId) => ajax(`${header}/v1/user-learn-report/service-info?userProductId=${userProductId}`);

// 查询用户学习报告周学习时长信息
export const reqStudyWeekTime = (userProductId) => ajax(`${header}/v1/user-learn-report/study-times?userProductId=${userProductId}`);

// 导学推荐接口
export const lerningGuidanceInfo = (productId, skuId) => ajax(`${header}/v1/user/course/recommend?productId=${productId}&skuId=${skuId}`);

//
//
//
// 学习进度-----新接口
// 获取章章节练习相关信息
export const reqNewPracticeProgress = (chapterId, productCurriculumId, userProductId) => ajax(`${header}/v1/user/course/chapter-practice-progress?chapterId=${chapterId}&productCurriculumId=${productCurriculumId}&userProductId=${userProductId}`);

// 获取用户的章节相关的学习进度
export const reqNewLearnProgress = (userProductId) => ajax(`${header}/v1/user/course/learn-progress?userProductId=${userProductId}`);
